/* eslint-disable no-undef */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Select from './Select';
import './style.sass';

class MainSearch extends Component {
  prepareDataForSelect = (array, valueField, titleField) => array.map(
    item => ({ value: item[valueField], title: item[titleField] }),
  );

  DropDownHandler = (e) => {
    window.location = `${window.location.protocol}//${window.location.host}${e.target.value}`;
  }

  render() {
    const { dropDownItems } = this.props;
    const dropDownItemTypes = Object.keys(dropDownItems);
    const ddiClassName = `ddi-${dropDownItemTypes.length}`;

    return (
      <div className="row">
        <div className="col-xs-12">
          <div className={`main-search ${ddiClassName}`}>
            <h3 className={`white bold main-search__title ${ddiClassName}`}>
              {I18n.t('generic.find_your_office')}
            :
            </h3>
            { dropDownItemTypes.map((itemsType, index) => {
              const preparedDropDownItems = this.prepareDataForSelect(dropDownItems[itemsType], 'uri', 'name');

              return (
                <React.Fragment>
                  { index > 0 && (
                    <h3 className={`white bold main-search__devider ${ddiClassName}`}>
                      {I18n.t('generic.or')}
                    </h3>
                  )}
                  <Select name={itemsType} controlFunc={this.DropDownHandler} options={preparedDropDownItems} />
                </React.Fragment>
              );
            })}
          </div>
        </div>
      </div>
    );
  }
}

MainSearch.propTypes = {
  dropDownItems: PropTypes.oneOfType([PropTypes.array]),
};

MainSearch.defaultProps = {
  dropDownItems: [],
};

export default MainSearch;
